export default __webpack_public_path__ + "static/media/mystry-banner.d179ae9a.png";